import { render } from "./mitt-konto.vue?vue&type=template&id=79fb2a96"
import script from "./mitt-konto.vue?vue&type=script&lang=js"
export * from "./mitt-konto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__